import { AviatorRolesTable } from './AviatorRolesTable';

export const AviatorRolesList: React.FC = () => {
  return <AviatorRolesTable />;
};
